// crewbit-admin/src/lib/activityPills.ts
//
// Mirrors crewbit-mobile/lib/activityPills.ts.
// Pure mapping function per docs/references/MONEY_MODULE_SPEC_v1.md §Overview.7.4.

export type ActivityPillColor = 'success' | 'warning' | 'info' | 'neutral';

export interface ActivityPill {
  label: string;
  color: ActivityPillColor;
  direction: 'in' | 'out' | null;
}

export function activityTypeToPill(activityType: string): ActivityPill {
  const normalized = activityType.toLowerCase().replace(/\s+/g, '_');
  switch (normalized) {
    case 'payment_recorded':
    case 'invoice_paid':
    case 'project_payment_recorded':
      return { label: 'Paid', color: 'success', direction: 'in' };
    case 'expense_recorded':
      return { label: 'Expense', color: 'warning', direction: 'out' };
    case 'vendor_bill_paid':
      return { label: 'Bill paid', color: 'warning', direction: 'out' };
    case 'invoice_emailed':
    case 'invoice_created':
    case 'invoice_sent':
      return { label: 'Sent', color: 'info', direction: null };
    case 'dispute_opened':
    case 'dispute_charged_back':
      return { label: 'Dispute', color: 'warning', direction: null };
    case 'payout_paid':
    case 'payout_in_transit':
      return { label: 'Payout', color: 'neutral', direction: null };
    case 'kyc_status_changed':
      return { label: 'KYC', color: 'warning', direction: null };
    case 'receipt_uploaded':
    case 'receipt_needs_review':
      return { label: 'Receipt', color: 'info', direction: null };
    default:
      return { label: '', color: 'neutral', direction: null };
  }
}
